import { FormikHelpers, useFormik } from 'formik';
import { breadcrumb, log } from '@modules/logging';
import { saveInterview } from '@modules/firebase/interviews';
import { useInterviewOptions } from '@providers/InterviewsProvider';
import { prepareInterviewToSavetoDB } from './CreateSurvey/CreateSurveyUtils';
import { stringFromError } from '@modules/firebase/firestore-utils';
import { interviewSchema } from './interviewSchema';
import type { InterviewEdited } from './types';

export const useCreateInterviewFormController = (
    initialValues: InterviewEdited | null, // existing values for "edit"
) => {
    const { fetchInterviews, selectedInterview } = useInterviewOptions();

    async function onSubmit(interview: InterviewEdited, actions: FormikHelpers<InterviewEdited>) {
        const groupId = selectedInterview?.groupId;
        const interviewId = selectedInterview?.id;

        try {
            if (interviewId && groupId) {
                actions.setSubmitting(true);

                // try to save the interview
                const savedInterview = await saveInterview(
                    groupId,
                    prepareInterviewToSavetoDB(interview),
                );
                actions.setSubmitting(false);
                if (savedInterview) {
                    fetchInterviews();
                }
            } else {
                throw new Error(`invalid  new interview: ${interview}`);
            }
        } catch (err) {
            breadcrumb(`[useCreateInterviewFormController]`, 'form', {
                error: stringFromError(err),
            });
            log('Save Survey Failed', {
                groupId,
                interviewId,
                interview,
            });
        }
    }

    const form = useFormik<InterviewEdited>({
        enableReinitialize: true,
        initialValues: initialValues || ({} as InterviewEdited),
        onSubmit,
        validationSchema: interviewSchema,
        validateOnMount: true,
        validateOnChange: true,
    });

    return form;
};
